import React from "react";
import {StyleDiv} from "components/Common/StyleDiv";
import {StyleImg} from "components/Common/StyleImg";

// Muted teal measured on the previous sign-in photo, whose tint was baked into the file
const PHOTO_TINT = "#5ea0a1";

function LogoWithBackground() {
  return (
    <StyleDiv position="relative" height="100vh">
      <StyleImg
        position="absolute"
        top="0"
        left="0"
        height="100%"
        width="100%"
        objectFit="cover"
        src="/assets/images/sign-in-sailing.jpg"
        alt="sailing-image"
      />
      {/* Keeps the photo's light and shade, recolours it teal */}
      <StyleDiv
        position="absolute"
        top="0"
        left="0"
        height="100%"
        width="100%"
        style={{backgroundColor: PHOTO_TINT, mixBlendMode: "color", pointerEvents: "none"}}
      />
    </StyleDiv>
  );
}

export default LogoWithBackground;
